export default __webpack_public_path__ + "static/media/Graphics_Postcard-5-min.1b1df208.jpg";